import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {CoachingReportModel} from '../../model/coaching-report.model';
import {CoachingReportSimpleModel} from '../../model/coaching-summary.model';
import {EventsService} from '../../../../services/events.service';
import {CoachingService} from '../../service/coaching.service';
import {Subscription} from 'rxjs';
import {AnalyticsService} from '../../../../services/analytics.service';
import {FormSavedModel} from '../../../../services/models/events.model';

@Component({
    selector: 'app-coaching-report-single',
    templateUrl: './coaching-report-single.component.html',
    styleUrls: ['./coaching-report-single.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class CoachingReportSingleComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    @Input() report: CoachingReportSimpleModel = null;

    private _active = false; // tslint:disable-line:variable-name

    get active(): boolean {
        return this._active;
    }

    @Input()
    set active(value: boolean) {
        if (value && !this.waitingOnInit) {
            this.updateReport();
        }
        this._active = value;
    }

    waitingOnInit = true;

    pageData: CoachingReportModel = null;
    pageDataValid = false;
    pageDataPromise: Promise<CoachingReportModel> = null;

    constructor(
        private event: EventsService,
        private coachingService: CoachingService,
        private analytics: AnalyticsService,
    ) {
        this.subscriptions.push(
            this.event.subscribe('form:saved', (data: FormSavedModel) => {
                if (data.name === 'coaching' && data.id === this.report.id) {
                    this.pageDataValid = false;
                    this.updateReport();
                }
            })
        );
    }

    ngOnInit() {
        this.waitingOnInit = false;
        if (this.active) {
            this.updateReport();
        }
    }

    updateReport() {
        if (!this.pageDataValid) {
            this.pageDataPromise = this.coachingService.getCoachingReport(this.report.id);
            this.pageDataPromise.then(data => {
                this.pageData = data;
                this.pageDataValid = true;
            });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
